import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { AdminSectionEntry } from './admin-section-entry.model';
import { AdminSectionRegistryService } from './admin-section-registry.service';

/**
 * Registers an {@link AdminSectionEntry} during application bootstrap so the BrightNav admin
 * home page can list it. Call from a feature `provideXxx()` bundle (for example the copilot providers).
 *
 * @param entry Section metadata; same `id` replaces a previous registration.
 * @returns Providers suitable for spreading into `ApplicationConfig.providers`.
 */
export function provideAdminSectionEntry(entry: AdminSectionEntry): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      inject(AdminSectionRegistryService).register(entry);
    }),
  ]);
}
